import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import ChatRouter from "../pages/ChatRouter";
import HomeRouter from "../pages/HomeRouter";
import LoginRouter from "../pages/LoginRouter";
import RegisterRouter from "../pages/RegisterRouter";
import PrivacyRouter from "../pages/PrivacyRouter";
import TermsRouter from "../pages/TermsRouter";
import RequestRouter from "../pages/RequestRouter";
import ResetRouter from "../pages/ResetRouter";
import { useProduct } from "../context/ProductContext";
import SiteRouter from "../pages/Site/SiteRouter";
import CanvasRouter from "../pages/Canvas/CanvasRouter";


const Main = () => {
    const { product } = useProduct();
    return (
      
      <BrowserRouter>
        
          <div className={`app theme-${product ?? 'default'}`}>
          <Routes>
            <Route path="/" element={<HomeRouter />}/>
            <Route path="/login" element={<LoginRouter />}/>
            <Route path="/register" element={<RegisterRouter />}/>
            <Route path="/forgot-password" element={<RequestRouter />}/>
            <Route path="/reset-password" element={<ResetRouter />}/>
            <Route path="/dashboard" element={<Dashboard />}/>
            <Route path="/chat/bot/:botSlug" element={<ChatRouter />}/>
            <Route path="/chat/site/:botSlug" element={<SiteRouter />}/>
            <Route path="/chat/canvas/:botSlug" element={<CanvasRouter />}/>
            <Route path="/privacypolicy" element={<PrivacyRouter/>}/>
            <Route path="/termsofservice" element={<TermsRouter />}/>
          </Routes>
          </div>
      </BrowserRouter>
    );
}

export default Main;
